import { BASE_URL } from '../constants'

const token = JSON.parse(localStorage.getItem('token'))

export const getEncodeData = async (data) => {
  const rawBody = JSON.stringify({
    token: data,
  })

  const URL = `${BASE_URL}/decode`

  try {
    const res = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: rawBody,
    })

    const getData = await res.json()
    console.log('getEncodeData', getData)
    if (res?.status === 200) {
      localStorage.setItem('user-info', JSON.stringify(getData))
    } else {
      localStorage.removeItem('user-info')
    }

    return getData
  } catch (error) {
    console.log(error)
  }
}

/** Persists session in localStorage — same as a successful manual login. */
export const persistLoginSession = async (sessionData) => {
  if (sessionData?.msg !== 'Login') {
    localStorage.removeItem('token')
    return false
  }
  localStorage.setItem('token', JSON.stringify(sessionData))
  await getEncodeData(sessionData?.token)
  return true
}

const normalizeDecodedPayload = (decodedData) => {
  let raw = decodedData
  if (typeof raw === 'string') {
    try {
      raw = JSON.parse(raw)
    } catch {
      return {}
    }
  }
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {}

  const sources = [raw]
  if (raw.data && typeof raw.data === 'object' && !Array.isArray(raw.data)) {
    sources.push(raw.data)
  }
  if (raw.user && typeof raw.user === 'object' && !Array.isArray(raw.user)) {
    sources.push(raw.user)
  }
  if (raw.payload && typeof raw.payload === 'object' && !Array.isArray(raw.payload)) {
    sources.push(raw.payload)
  }
  return sources
}

const pickDecodedField = (sources, keys, { numeric = false } = {}) => {
  for (const source of sources) {
    for (const key of keys) {
      const value = source[key]
      if (value === undefined || value === null) continue
      if (!numeric && value === '') continue
      return value
    }
  }
  return numeric ? '' : ''
}

/** Auto-login only: token from query param, user-info from decode response. */
export const mapDecodeResponseToUserInfo = (decodedData = {}) => {
  const sources = normalizeDecodedPayload(decodedData)

  return {
    username: pickDecodedField(sources, ['username', 'user', 'userName']),
    email: pickDecodedField(sources, ['email']),
    typeUser: pickDecodedField(sources, ['typeUser', 'type_user', 'typeOfUser'], {
      numeric: true,
    }),
    cdo: pickDecodedField(sources, ['cdo'], { numeric: true }),
    venc: pickDecodedField(sources, ['venc'], { numeric: true }),
  }
}

/** Auto-login only: token from query param, user-info from decode response. */
export const persistCompanyAutoLoginSession = (queryToken, decodedData = {}) => {
  const tokenStorage = {
    msg: 'Login',
    tag: 'SUCCESS',
    token: queryToken,
  }

  const fields = mapDecodeResponseToUserInfo(decodedData)
  const typeUser =
    fields.typeUser !== '' && fields.typeUser !== undefined
      ? Number(fields.typeUser)
      : ''

  const userInfo = {
    payload: {
      username: fields.username,
      email: fields.email,
      typeUser,
      cdo: fields.cdo !== '' ? Number(fields.cdo) : '',
      venc: fields.venc !== '' ? Number(fields.venc) : '',
    },
  }

  localStorage.setItem('token', JSON.stringify(tokenStorage))
  localStorage.setItem('user-info', JSON.stringify(userInfo))
  return userInfo
}

/** Exchanges a session code for a real session JWT (tokenSession). */
export const getSessionByCode = async (code) => {
  const rawBody = JSON.stringify({ code })
  const URL = `${BASE_URL}user/sessionCode`

  try {
    const res = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: rawBody,
    })
    const getData = await res.json()
    return { res, getData }
  } catch (error) {
    console.log(error)
    return { res: null, getData: null }
  }
}

/** Decodes a company culture token without touching localStorage. */
export const decodeCompanyToken = async (cultureToken) => {
  const rawBody = JSON.stringify({ token: cultureToken })
  const URL = `${BASE_URL}/decode`

  try {
    const res = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: rawBody,
    })
    const getData = await res.json()
    return { res, getData }
  } catch (error) {
    console.log(error)
    return { res: null, getData: null }
  }
}

export const logOut = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('user-info')
}

export const forgetPassword = async (data) => {
  const rawBody = JSON.stringify({
    email: data.email,
  })

  const URL = `${BASE_URL}servicesForUsers/sedingEmailForPasswordRecovery`

  try {
    const res = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: rawBody,
    })
    const getData = await res.json()

    return { getData, res }
  } catch (error) {
    console.log(error)
  }
}

export const recoveryPassword = async (data) => {
  const rawBody = JSON.stringify({
    password: data.password,
  })

  const URL = `${BASE_URL}servicesForUsers/passwordRecovery`

  try {
    const res = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        token_auth: data.code ?? '',
      },
      body: rawBody,
    })
    const getData = await res.json()

    return { res, getData }
  } catch (error) {
    console.log(error)
  }
}

export const changePassword = async (data) => {
  const rawBody = JSON.stringify(data)

  const URL = `${BASE_URL}changepassworduser`

  try {
    const res = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const getData = await res.json()

    return { res, getData }
  } catch (error) {
    console.log(error)
  }
}

export const sendCodeChangeEmail = async (data) => {
  const rawBody = JSON.stringify(data)

  const URL = `${BASE_URL}validatecangeemail`

  try {
    const res = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const getData = await res.json()

    return { res, getData }
  } catch (error) {
    console.log(error)
  }
}

export const changeEmail = async (data) => {
  const rawBody = JSON.stringify(data)

  const URL = `${BASE_URL}changeenamil`

  try {
    const res = await fetch(URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const getData = await res.json()

    return { res, getData }
  } catch (error) {
    console.log(error)
  }
}

export const verifyPassword = async (data) => {
  const rawBody = JSON.stringify(data)

  const URL = `${BASE_URL}user/validationPass`

  try {
    const res = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const getData = await res.json()

    return { res, getData }
  } catch (error) {
    console.log(error)
  }
}

export const getSettings = () => {
  const URL = `${BASE_URL}/user/settings/get`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res?.settings)

    return response
  } catch (error) {
    console.log(error)
  }
}

export const changeNotificationState = async (data) => {
  const rawBody = JSON.stringify(data)

  const URL = `${BASE_URL}user/settings/setNotifications`

  try {
    const res = await fetch(URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const getData = await res.json()

    return { res, getData }
  } catch (error) {
    console.log(error)
  }
}

export const accountClosure = async (data) => {
  const rawBody = JSON.stringify(data)

  const URL = `${BASE_URL}user/accountClosure`

  try {
    const res = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const getData = await res.json()

    return { res, getData }
  } catch (error) {
    console.log(error)
  }
}
